import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

const appName = process.env.REACT_APP_CENTRE_NAME || 'LifeChiAI';
serviceWorkerRegistration.register({
  onSuccess: () => console.log(appName + ': App ready for offline use'),
  onUpdate: () => console.log(appName + ': New version available — refresh to update')
});
